import React from 'react';

export const HighVoltageSignSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32.9378 15.651C32.7918 15.26 32.4178 15 31.9998 15H19.9248L26.8898 1.458C27.1088 1.032 26.9958 0.511 26.6188 0.215C26.4368 0.071 26.2178 0 25.9998 0C25.7668 0 25.5338 0.082 25.3468 0.243L17.9998 6.588L3.34684 19.243C3.03084 19.516 2.91684 19.957 3.06284 20.348C3.20884 20.739 3.58184 21 3.99984 21H16.0748L9.10984 34.542C8.89084 34.968 9.00384 35.489 9.38084 35.785C9.56284 35.929 9.78184 36 9.99984 36C10.2328 36 10.4658 35.918 10.6528 35.757L17.9998 29.412L32.6528 16.757C32.9698 16.484 33.0828 16.043 32.9378 15.651Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32.9378 15.651C32.7918 15.26 32.4178 15 31.9998 15H19.9248L26.8898 1.458C27.1088 1.032 26.9958 0.511 26.6188 0.215C26.4368 0.071 26.2178 0 25.9998 0C25.7668 0 25.5338 0.082 25.3468 0.243L17.9998 6.588L3.34684 19.243C3.03084 19.516 2.91684 19.957 3.06284 20.348C3.20884 20.739 3.58184 21 3.99984 21H16.0748L9.10984 34.542C8.89084 34.968 9.00384 35.489 9.38084 35.785C9.56284 35.929 9.78184 36 9.99984 36C10.2328 36 10.4658 35.918 10.6528 35.757L17.9998 29.412L32.6528 16.757C32.9698 16.484 33.0828 16.043 32.9378 15.651Z" fill="#FFC700" />
    </svg>
  )
}